// extracted by mini-css-extract-plugin
export default {"wrapper":"to-z","response":"uo-z","error":"vo-z","disabled":"wo-z","buttons":"xo-z","feedbackQuestionSection":"yo-z","yesNoWrapper":"zo-z"};